// removed by extract-text-webpack-plugin
module.exports = {"companyLinks":"Person__companyLinks___WkItF"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Person/components/Person.scss
// module id = 1217
// module chunks = 1